import { HEADER } from "./constants";
import { AlertType } from "/types/alerts.d";

export const getAlertBannerType = (alertType: AlertType, isExpired: boolean): string => {
	if (isExpired) return HEADER.EXPIRED;
	if (alertType === 'vaer-varsom') return HEADER.ACTIVE_CAREFUL;
	return HEADER.ACTIVE;
};
